import { useCoreInput } from "@Shared/@Composables/inputs/useCoreInput";
import { defineComponent, ref, toRefs } from "@vue/composition-api";
export default defineComponent({
  name: "BaseInput",
  props: {
    value: {
      type: null,
      default: null
    },
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    inputMask: {
      type: Object,
      default: () => ({})
    },
    inputType: {
      type: String,
      default: "text"
    },
    browserAutocomplete: {
      type: Boolean,
      default: false
    },
    onType: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const {
      value,
      onType
    } = toRefs(props);
    const {
      handleBaseFocus,
      handleBaseBlur,
      handleBaseChange,
      handleBaseInput,
      handleKeypressEnter,
      valueModel
    } = useCoreInput({
      value,
      onType: onType.value
    });
    const inputRef = ref();
    const focus = () => {
      var _inputRef$value;
      inputRef == null ? void 0 : (_inputRef$value = inputRef.value) == null ? void 0 : _inputRef$value.focus();
    };
    const blur = () => {
      var _inputRef$value2;
      inputRef == null ? void 0 : (_inputRef$value2 = inputRef.value) == null ? void 0 : _inputRef$value2.blur();
    };
    return {
      inputRef,
      valueModel,
      handleBaseFocus,
      handleBaseBlur,
      handleBaseChange,
      handleBaseInput,
      handleKeypressEnter,
      focus,
      blur
    };
  }
});